import { createSelector } from '@reduxjs/toolkit'
import { TRootState } from 'store/types'

const selector = (state: TRootState) => state.credits

const featureOperationCosts = createSelector(
  selector,
  state => state.featureOperationCosts
)

const userCredits = createSelector(selector, state => state.userCredits)

export const creditsSelectors = {
  featureOperationCosts,
  userCredits
}
